import { Box, Button, Card, CardContent, CardHeader, Divider } from "@mui/material";

const pageTitle = "Goal";

export default function KpiDataGoal() {
    return (
        <Card variant="outlined">
            <CardHeader title={pageTitle}></CardHeader>

            <Divider variant="middle" />

            <CardContent sx={{ padding: 2 }}>coming soon</CardContent>
        </Card>
    );
}
